import _ from 'lodash'
import attributes from '../settings/references.json'
import common from '../settings/common.localization.json'

const getTexts = (strings) => {
    let first = null
    return _.reduce(
        attributes.languages,
        (r, v, k) => {
            if (first == null) {
                first = { ...common[k], ...strings[k] }
            }
            r[k] = { ...first, ...common[k], ...strings[k] }
            return r
        },
        {},
    )
}

export default getTexts



// WEBPACK FOOTER //
// ./src/store/localizer.js